/**
 * TeamItemsCard.js
 *
 * The items a team has bought, with what they paid. Always shown to the team itself.
 */

import React from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../../../components/ui/Card";

const TeamItemsCard = ({ items, scoreAttribute }) => {
    return (
        <Card className="bg-zinc-900 border-zinc-700 shadow-md">
            <CardHeader className="pb-2 text-left">
                <CardTitle className="text-sm text-zinc-400">Your Items</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col divide-y divide-zinc-700">
                {items.length === 0 ? (
                    <p className="text-zinc-400 italic text-sm mt-2">Nothing bought yet.</p>
                ) : (
                    items.map((item, index) => (
                        <div key={index} className="flex items-center justify-between gap-4 py-3 text-left">
                            <div>
                                <div className="text-lg font-medium text-zinc-100">{item.name}</div>
                                <div className="text-sm text-zinc-400">{scoreAttribute} {item.score}</div>
                            </div>
                            {item.soldPrice !== undefined && <span className="font-mono text-zinc-300">₹{item.soldPrice}</span>}
                        </div>
                    ))
                )}
            </CardContent>
        </Card>
    );
};

export default TeamItemsCard;
